document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aa-collection__controls').forEach(controls => {
    const root = controls.closest('.aa-collection');
    const panel = root.querySelector('.aa-collection__facets');
    const opener = root.querySelector('[data-aa-filter-open]');
    const closer = root.querySelector('[data-aa-filter-close]');
    const media = matchMedia('(max-width: 989px)');
    const backdrop = document.createElement('button');
    backdrop.className = 'aa-filter-backdrop';
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', closer?.getAttribute('aria-label') || 'Close filters');
    backdrop.hidden = true;
    root.append(backdrop);
    let previousFocus;
    const close = () => {
      panel?.classList.remove('is-open');
      document.body.classList.remove('aa-filter-open');
      backdrop.hidden = true;
      opener?.setAttribute('aria-expanded', 'false');
      if (panel) panel.inert = media.matches;
      previousFocus?.focus();
    };
    const sync = () => { close(); if (panel) panel.inert = media.matches; };
    opener?.setAttribute('aria-controls', panel.id);
    opener?.setAttribute('aria-expanded', 'false');
    opener?.addEventListener('click', () => {
      previousFocus = document.activeElement;
      panel.inert = false;
      panel.classList.add('is-open');
      document.body.classList.add('aa-filter-open');
      backdrop.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      closer?.focus();
    });
    closer?.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    media.addEventListener('change', sync);
    sync();
    panel?.addEventListener('keydown', event => {
      if (!media.matches || !panel.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'Tab') {
        const focusable = [...panel.querySelectorAll('a[href],button,input,select,summary')].filter(el => !el.disabled && el.getClientRects().length);
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    });
    const current = new URL(location.href);
    root.querySelectorAll('[data-aa-native-filter]').forEach(form => {
      for (const name of ['preview_theme_id','_ab','_fd','_sc']) {
        if (!current.searchParams.has(name)) continue;
        const input = document.createElement('input');
        input.type='hidden'; input.name=name; input.value=current.searchParams.get(name); form.append(input);
      }
      form.addEventListener('change', event => { if(event.target.type === 'checkbox') form.requestSubmit(); });
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[type=number]').forEach(input => { if(input.value==='') input.disabled=true; });
      });
    });
    root.querySelectorAll('[data-aa-spec-link]').forEach(link => {
      const next = new URL(link.href);
      next.search = current.search;
      next.searchParams.delete('page');
      next.searchParams.delete('section_id');
      link.href=next.href;
    });
    root.querySelector('[data-aa-sort-open]')?.addEventListener('click', () => {
      root.querySelector('.aa-collection__sort')?.classList.toggle('is-open');
      root.querySelector('#SortBy')?.focus();
    });
    root.querySelector('#SortBy')?.addEventListener('change', event => {
      current.searchParams.set('sort_by', event.target.value);
      current.searchParams.delete('page');
      location.assign(current.href);
    });
  });
});

